<template>
  <div class="tblFilterHesabCode">
    <div class="table-respon" style="max-height: 140px; overflow-y: auto">
      <table class="table table-bordered table-sm text-center table-font-size">
        <!-- سربرگ جدول -->
        <thead class="bg-primary-light sticky-top">
          <td>ردیف</td>
          <td>کد حساب</td>
          <td>عنوان حساب ({{ TbBaseAccDataFilter.length }} مورد)</td>
        </thead>
        <tbody>
          <tr
            v-for="row in getListDataPaging"
            :key="row.NCode"
            v-on:click="selectRow(row.NCode, row.SDesc, row.NAccType, row.NPerID)"
            v-on:dblclick="dblClickRow(row.NCode, row.SDesc, row.NAccType, row.NPerID)"
            v-bind:id="'rowFilter-' + row.NCode"
            :class="{ selRow: selectRowID == row.NCode }"
            style="cursor: pointer;"
          >
            <td>{{ row.RowID }}</td>
            <td>{{ row.NCode }}</td>
            <td style="    
              max-width: 200px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            "
            :title="row.SDesc"
            >{{ row.SDesc }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row h12 text-secondary mt-2 d-flex justify-content-center align-items-center">
      <div class="col-9 text-right p-0">
        راهنما : فلش <i class="fas fa-long-arrow-alt-up px-1"></i> و <i class="fas fa-long-arrow-alt-down px-1"></i> حرکت بین سطرها ، F4/Enter انتخاب
      </div>
      <div class="col-3 text-left p-0">
        <PaginationSmallHesabCode
          v-bind:Name="'PaginationSmallHesabCode'" 
          v-bind:CountRow="intCountRow"
          v-bind:DataRepository="TbBaseAccDataFilter" 
          v-on:ChangePage="ChangePage"
        ></PaginationSmallHesabCode>
      </div>
    </div>
  </div>
</template>

<script>
import { BusEvent } from "../../../../../main.js";
import PaginationSmallHesabCode from "../../PublicComponents/PaginationSmall.vue"

export default {
  name: "FilterHesabCode",
  components:{
    PaginationSmallHesabCode
  },
  data() {
    return {
      TbBaseAccData: [],
      TbBaseAccDataFilter: [],

      selectRowID: 0,
      selectRowType: 0,
      selectRowSDesc: "",
      selectRowNPerID: 0,

      // مربوط به صفحه بندی
      intPageNumber: 1,  // شماره صفحه در حال انتخاب
      intCountRow: 100,   // تعداد سطرها در هر صفحه
      intCountPage: 1,   // تعداد کل صفحه ها
      intCountRowShow: 1, // تعداد سطرهای مشاهده شده در صفحه - ممکن است صفحه 200 سطر کامل نباشد

    };
  },
  props: ["RandomNumberChild","HesabCode"],
  watch: {
    RandomNumberChild: function (value) {
      this.filterTbBaseAccData(this.HesabCode);
    },
    HesabCode: function (value) {
      this.filterTbBaseAccData(this.HesabCode);
    }
  },
  computed: {
    // نمایش اطلاعات با قابلیت صفحه بندی
    getListDataPaging() {
      if (this.TbBaseAccDataFilter.length > 0) {
        // شماره شروع رکورد
        let startRowIndex = this.intPageNumber == 1 ? 1 : (parseInt(this.intCountRow) * (parseInt(this.intPageNumber) - 1) + 1);
        let intCountRowLocal = this.intCountRow;
        // انتخاب رکوردهای صفحه مورد نظر
        let ListTemplate = [];
        ListTemplate = this.TbBaseAccDataFilter.filter(function (item) {
          return (item.RowID >= startRowIndex && item.RowID < (parseInt(startRowIndex) + parseInt(intCountRowLocal)))
        });
        // خروجی لیست صفحه مورد نظر
        return ListTemplate;
      } else {
        return [];
      }
    },
  },
  methods: {
    // رویداد تغییر صفحه از کامپاننت صفحه بندی
    ChangePage(value) {
      this.intPageNumber = value.pageNumber;
      this.intCountRow = value.countRow;
      this.intCountPage = value.countPage;
    },
    getTbBaseAccData() {
      this.TbBaseAccData = this.$store.getters.getTbBaseAccData;
      this.TbBaseAccDataFilter = this.TbBaseAccData;
    },

    async filterTbBaseAccData(NCode) {
      if(NCode != 0 && NCode != ''){
        this.TbBaseAccDataFilter = this.TbBaseAccData.filter(function (t) {
          return t.NCode.includes(NCode);
        });
        // درج شماره ردیف برای لیست
        this.TbBaseAccDataFilter = await this.$store.dispatch('setRowIDForList', this.TbBaseAccDataFilter);
      } else {
        this.TbBaseAccDataFilter = this.TbBaseAccData;
      }
    },

    dblClickRow(NCode, SDesc, NAccType, NPerID) {
      this.selectRow(NCode, SDesc, NAccType, NPerID);
      this.SelectHesab();
    },

    selectRow(NCode, SDesc, NAccType, NPerID) {
      this.selectRowID = NCode;
      this.selectRowSDesc = SDesc;
      this.selectRowType = NAccType;
      this.selectRowNPerID = NPerID;
    },

    SelectHesab() {
      if (this.selectRowID == 0) {
        this.$store.dispatch(
          "notify",
          "حسابی در حالت انتخاب نیست !\nلطفا ابتدا یکی از حساب ها را در حالت انتخاب قرار دهید ."
        );
      } else {
        this.$emit("HideFilterHesab", {
          NCode: this.selectRowID,
          SDesc: this.selectRowSDesc,
          NAccType: this.selectRowType,
          NPerID: this.selectRowNPerID
        });
      }
    },

    // تابع مدیریت کلید میانبرها داخل سند
    hotKeyChecker(keyvalue) {
      //alert('filter hesab : ' + keyvalue.key);
      if (this.TbBaseAccDataFilter.length > 0) {
        if (keyvalue.key === "ArrowUp" || keyvalue.key === "ArrowDown") {
          let index = this.TbBaseAccDataFilter.findIndex(
            (itme) => itme.NCode == this.selectRowID
          );
          if (index != -1) {
            if (keyvalue.key === "ArrowUp") {
              if (index > 0) {
                this.selectRow(
                  this.TbBaseAccDataFilter[index - 1].NCode,
                  this.TbBaseAccDataFilter[index - 1].SDesc,
                  this.TbBaseAccDataFilter[index - 1].NAccType,
                  this.TbBaseAccDataFilter[index - 1].NPerID
                );
                $(
                  "#rowFilter-" + this.TbBaseAccDataFilter[index - 1].NCode
                ).scrollintoview({
                  duration: 100,
                  //complete: this.$store.dispatch("notify", "تست نمایش پیام"),
                });
              }
            } else {
              if (index + 1 < this.TbBaseAccDataFilter.length) {
                this.selectRow(
                  this.TbBaseAccDataFilter[index + 1].NCode,
                  this.TbBaseAccDataFilter[index + 1].SDesc,
                  this.TbBaseAccDataFilter[index + 1].NAccType,
                  this.TbBaseAccDataFilter[index + 1].NPerID
                );
                $(
                  "#rowFilter-" + this.TbBaseAccDataFilter[index + 1].NCode
                ).scrollintoview({
                  duration: 100,
                  //complete: this.$store.dispatch("notify", "تست نمایش پیام"),
                });
              }
            }
          } else {
            this.selectRow(
              this.TbBaseAccDataFilter[0].NCode,
              this.TbBaseAccDataFilter[0].SDesc,
              this.TbBaseAccDataFilter[0].NAccType,
              this.TbBaseAccDataFilter[0].NPerID
            );
          }
        }
        // انتخاب سطر و بستن پنجره
        if (keyvalue.key === "F4" || keyvalue.key === "Enter") {
          this.SelectHesab();
        }
      }
    },
  },
  created() {
    //alert('create Filter');
    this.getTbBaseAccData();
    BusEvent.$on("keyPressValue", this.hotKeyChecker);
  },
  beforeDestroy() {
    //alert('Destroy Filter');
    BusEvent.$off("keyPressValue", this.hotKeyChecker);
  },
};
</script>

<style scoped>
.tblFilterHesabCode {
  position: absolute;
  background-color: #fee3e8;
  width: 400px;
  min-height: 80px;
  /* max-height: 170px; */
  margin-top: 35px;
  z-index: 99999;
  /* top: 52px; */
  padding: 5px;
  border-radius: 5px;
  box-shadow: rgb(0 0 0 / 40%) 0px 0px 5px;
}

.tblFilterHesabCode table {
  background-color: white;
}

.selRow {
  background-color: #fbff94;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/NewAccDoc/Components/FilterHesabCode.vue